import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { applicationTitle } from "@/utils/common";

const BlankLayout = () => {
  const title = applicationTitle();

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Box>
        <Outlet />
      </Box>
    </>
  );
};

export default BlankLayout;
